export enum DeepLinkSearchParams {
  crmOrgId = 'cid',

  /* automation */
  automationType = 'tp',
  automationId = 'aid',
  versionId = 'vid',

  /* Territory */
  territoryId = 'tid',

  /* Assignment group */
  groupId = 'gid',

  /* rollup */
  rollupId = 'rid',

  /* documentation */
  objectName = 'on',
  activeTab = 'atb',
  configurationItemId = 'ciid',
  apexClassParentId = 'acpid',
  isExpandedMode = 'ex',
}
